var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"checkpoint-criteria-bar",class:_setup.rootClass},[_c('span',{staticClass:"checkpoint-criteria-bar__text"},[_vm._v(_vm._s(_vm.criteria_with_prefix))])])
}
var staticRenderFns = []

export { render, staticRenderFns }